export class MindboxTracker {
    operationSend(operation, data) {
        window.mindbox('async', {
            operation: operation,
            data: data,

            onSuccess: function() {
                console.info('OK MindboxTracker ' + operation + ': %o', data);
            },
            onError: function(error) {
                console.error('ERROR MindboxTracker: ' + operation + ' ' + error);
            }
        });
    }

    /**
     * Трекер раздела товаров+
     * @param category
     */
    categoryView(category) {
        this.operationSend('CategoryView', {
            viewProductCategory: {
                productCategory: {
                    ids: {
                        smartBuy: category.id
                    }
                }
            }
        });
    }

    /**
     * Трекер детальной страницы товара+
     * @param product
     */
    productView(product) {
        this.operationSend('ProductView', {
            viewProduct: {
                price: product.price,
                product: {
                    ids: {
                        smartBuy: product.vendorCode
                    }
                }
            }
        });
    }

    /**
     * Трекер добавления товара в корзину-
     * @param basketData
     */
    setCart(basketData) {
        this.operationSend('SetCart', basketData);
    }

    /**
     * Трекер добавления товара в избранное+
     * @param productsData
     */
    setWishList(productsData) {
        this.operationSend('SetWishList', productsData);
    }

    /**
     * Трекер авторизации пользователя+
     * @param phone
     */
    authorization(phone) {
        this.operationSend('Authorization', {
            customer: {
                mobilePhone: phone
            }
        });
    }
}



// WEBPACK FOOTER //
// ./modules/mindbox/mindbox-tracker.js